import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--sortable-list"
export default class extends Controller {
  // position, moveUpButton, moveDownButtonはitemに紐づく属性なので、targetsには設定しない。
  static targets = ["item"];

  connect() {
    this.refresh();
  }

  moveUp(e) {
    e.preventDefault();
    const item = e.currentTarget.closest("[data-resumin--sortable-list-target='item']");
    const previousItem = item.previousElementSibling;

    if (previousItem) {
      const callback = () => {
        previousItem.before(item);
      };

      this._animateSwap(previousItem, item, callback);
    }
  }

  moveDown(e) {
    e.preventDefault();
    const item = e.currentTarget.closest("[data-resumin--sortable-list-target='item']");
    const nextItem = item.nextElementSibling;

    if (nextItem) {
      const callback = () => {
        nextItem.after(item);
      };
      this._animateSwap(item, nextItem, callback);
    }
  }

  refreshList(e) {
    e.preventDefault();
    this.refresh();
  }

  // FLIP（First, Last, Invert, Play）アニメーションを使用して、要素の位置をスワップします。
  async _animateSwap(previousItem, nextItem, callback) {
    const previousFirstRect = previousItem.getBoundingClientRect();
    const nextFirstRect = nextItem.getBoundingClientRect();
    const parentItem = previousItem.parentElement;
    const originalOverflowAnchor = parentItem.style.overflowAnchor;

    try {
      parentItem.style.overflowAnchor = "none";
      // 要素を移動させる
      callback();

      const previousLastRect = previousItem.getBoundingClientRect();
      const nextLastRect = nextItem.getBoundingClientRect();

      previousItem.style.transform = `translateY(${previousFirstRect.top - previousLastRect.top}px)`;
      nextItem.style.transform = `translateY(${nextFirstRect.top - nextLastRect.top}px)`;

      const animationOptions = {
        duration: 300,
        easing: "ease",
      };

      const previousAnimation = previousItem.animate([{ transform: previousItem.style.transform }, { transform: "translateY(0)" }], animationOptions);

      const nextAnimation = nextItem.animate([{ transform: nextItem.style.transform }, { transform: "translateY(0)" }], animationOptions);

      await Promise.all([previousAnimation.finished, nextAnimation.finished]);
      this.refresh();
    } finally {
      previousItem.style.transform = "";
      nextItem.style.transform = "";
      parentItem.style.overflowAnchor = originalOverflowAnchor;
    }
  }

  refresh() {
    const items = this.itemTargets;
    items.forEach((item, index) => {
      const position = item.querySelector("[data-resumin--sortable-list-target='position']");

      if (position) {
        position.value = index + 1;
      }

      const moveUpButton = item.querySelector("[data-resumin--sortable-list-target='moveUpButton']");
      const moveDownButton = item.querySelector("[data-resumin--sortable-list-target='moveDownButton']");

      if (moveUpButton) {
        const isFirst = index === 0;
        moveUpButton.disabled = isFirst;
        moveUpButton.classList.toggle("is-disabled", isFirst);
      }

      if (moveDownButton) {
        const isLast = index === items.length - 1;
        moveDownButton.disabled = isLast;
        moveDownButton.classList.toggle("is-disabled", isLast);
      }
    });
  }
}
